import { useEffect, useState } from "react";
import Header from "../components/Header/Header";
import Carousel from "../components/Carousel/Carousel";
import Button from "../components/Button/Button";
import { useParams, Link, Navigate } from "react-router-dom";
import '../css/ProjetDetails.css';
import { useTranslation } from 'react-i18next';
import { fetchProjects } from "../services/api";

const resolveIconPath = (icon) => (icon ? (icon.startsWith('/') ? icon : `/${icon}`) : null);

function ProjetDetail() {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [project, setProject] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      setIsLoading(true);
      try {
        const projectsData = await fetchProjects();
        if (!mounted) {
          return;
        }
        setProject((projectsData || []).find((projectItem) => projectItem.seturl === id) || null);
      } catch (error) {
        console.error('Erreur lors du chargement des données du projet', error);
        if (mounted) {
          setProject(null);
        }
      } finally {
        if (mounted) {
          setIsLoading(false);
        }
      }
    };

    loadData();
    return () => {
      mounted = false;
    };
  }, [id]);

  if (isLoading) {
    return <p>{t('projectDetails.loading')}</p>;
  }

  if (!project) {
    return <Navigate to="/" replace />;
  }

  return (
    <div>
      <Header title={project.nom[lang]} printPicture="false"/>
      <Link to="/projets" className="projet-detail-back">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
        {t('projectDetails.back')}
      </Link>
      <div className="projet-detail">
        <div className="projet-detail-carousel">
          {project.images && <Carousel images={project.images} className="carousel-container2"/>}
        </div>
        <div className="projet-detail-icons">
          {project.technologies.map((tech) => (
            <figure key={tech.id}>
              {resolveIconPath(tech.icon) ? (
                <img src={resolveIconPath(tech.icon)} alt={tech.label[lang] || tech.label.fr} />
              ) : (
                <span className="tech-placeholder">{tech.label[lang] || tech.label.fr}</span>
              )}
              <figcaption>{tech.label[lang] || tech.label.fr}</figcaption>
            </figure>
          ))}
        </div>
        <div className="projet-detail-copy">
          <h2 className="projet-detail-title">
            {project.nom[lang]}
            {project.logo && (
              <img className="projet-detail-logo" src={resolveIconPath(project.logo)} alt="" />
            )}
          </h2>
          <div className="projet-detail-contexte">
            <h3>{t('projectDetails.contextTitle')}</h3>
            <p className="projet-detail-paragraph">{project.contexte[lang]}</p>
          </div>
          <div className="projet-detail-description">
            <h3>{t('projectDetails.descriptionTitle')}</h3>
            <p className="projet-detail-paragraph">{project.description[lang]}</p>
          </div>
          {project.url && <Button url={project.url} texte={t('projectDetails.viewProject')} />}
        </div>
      </div>
    </div>
  );
}

export default ProjetDetail;
